import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
//api
import { getFavorites } from 'api/users';
import { deleteFavoriteProductUser } from 'api/users';
//slices
import { userSelector } from 'slices/user';
//components
import ItemListFavorites from 'components/itemListFavorites/item';
import Head from 'components/metatags_helmet/metatags';
import TitleWithLine from 'components/titleWithLine';
import NoResults from 'components/userzone/NoResults';
//images
import favorite from 'assets/img/ico_nofavorite.png';
//styles
import './favorites.scss';

const goUp = () => {
  window.scrollTo(0, 0);
};

const Favorites = () => {
  const [saved, setSaved] = useState([]);
  const [loading, setLoading] = useState(false);
  const { isLogged } = useSelector(userSelector);
  const { t } = useTranslation(['home']);
  const title = t('misFavoritos', { ns: 'header' });

  useEffect(() => {
    async function handleFavorites() {
      const rs = await getFavorites();
      if (rs.status === 200) {
        setSaved(rs.data.results);
      }
    }
    handleFavorites();
  }, []);

  const removeProductFav = async (item) => {
    if (isLogged) {
      const id = item.id;
      const updatedSaved = saved.filter((savedItem) => savedItem.id !== id);
      setSaved(updatedSaved);
      await deleteFavoriteProductUser(id);
    }
  };


  useEffect(() => {
    goUp();
  }, []);


  return (
    <Container fluid className="margin-top-md px-4 d-flex mainDiv">
      <Head title={title} noIndex={true} />
      {saved.length > 0 ? (
        <Row className="favorites">
          <Col lg={12}>
            <TitleWithLine text={title} />
          </Col>
          {saved?.map((item, i) => (
            <Col lg={2} className="margin-md">
              <ItemListFavorites key={i} data={item} removeProductFav={removeProductFav} />
            </Col>
          ))}
        </Row>
      ) : (
        <NoResults
          text={t('noproductsyfavoriteslist')}
          icon={favorite}
          className='noFavorites'
          showBackToHome={true} />
      )}
    </Container>
  );
};

export default Favorites;
